import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconTrash: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M18 6H20C20.6 6 21 6.4 21 7C21 7.6 20.6 8 20 8H19V20C19 20.6 18.6 21 18 21H6C5.4 21 5 20.6 5 20V8H4C3.4 8 3 7.6 3 7C3 6.4 3.4 6 4 6H6H7.5V4C7.5 3.4 7.9 3 8.5 3H15.5C16.1 3 16.5 3.4 16.5 4V6H18ZM14.5 5H9.5V6H14.5V5ZM7 19H17V8H15.5H8.5H7V19ZM10 10C9.4 10 9 10.4 9 11V16C9 16.6 9.4 17 10 17C10.6 17 11 16.6 11 16V11C11 10.4 10.6 10 10 10ZM14 10C13.4 10 13 10.4 13 11V16C13 16.6 13.4 17 14 17C14.6 17 15 16.6 15 16V11C15 10.4 14.6 10 14 10Z',
    })
  )
}
